export default {"src":"/_next/static/media/minus.781863ec.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};